import { render, staticRenderFns } from "./KpiSection.vue?vue&type=template&id=594a5daa&scoped=true"
import script from "./KpiSection.vue?vue&type=script&lang=js"
export * from "./KpiSection.vue?vue&type=script&lang=js"
import style0 from "./KpiSection.vue?vue&type=style&index=0&id=594a5daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a5daa",
  null
  
)

export default component.exports